import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { ButtonComponent } from '@mode/capra';
import { FeatureFlag, FeatureFlagsFacade, SlackChannel } from '@mode/shared/contract-common';
import { NotificationType, Schedule } from '@mode/shared/schedules/contract';
import { InfoBannerComponent, SchedulableEntity } from '@mode/shared/schedules/ui';
import { NoticesScrolling, SCROLL_SERVICE, ScrollService } from '../scroll-service';

@Component({
  selector: 'mode-schedule-editor-action-bar',
  standalone: true,
  providers: [
    {
      provide: SCROLL_SERVICE,
      useClass: ScrollService,
    },
  ],
  imports: [CommonModule, InfoBannerComponent, ButtonComponent],
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionBarComponent implements AfterViewInit {
  @Input() initialSchedule?: Schedule;
  @Input() isCreatingNewSchedule?: boolean;
  @Input() entity: SchedulableEntity = 'report';
  @Input() notifyType: NotificationType = 'none';
  @Input() schedule: Schedule = { frequency: 'daily', minute: 0, timeZone: 'UTC', hour: 0 };
  @Input() slackChannel?: SlackChannel;
  @Input() disableCreateButton?: boolean = false;

  @Output() backClicked = new EventEmitter();
  @Output() cancelClicked = new EventEmitter();
  @Output() deleteClicked = new EventEmitter();
  public ShowNamedSchedules: boolean | undefined;

  constructor(
    @Inject(SCROLL_SERVICE) public scrollService: NoticesScrolling,
    private elRef: ElementRef,
    private featureFlagsFacade: FeatureFlagsFacade
  ) {
    this.featureFlagsFacade.asObservable(FeatureFlag.ShowNamedSchedules).subscribe((enabled) => {
      this.ShowNamedSchedules = enabled;
    });
  }

  ngAfterViewInit() {
    this.scrollService.setLowerThreshold(this.elRef.nativeElement);
  }
}
